import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"
import Modal from "src/components/Modal"

import { reopenWorkOrder } from "src/api/Service/WorkOrders"

import { REOPEN_WORK_ORDER_PREFIX } from "./amplitude_events"
import useWorkOrderActionMutation from "./hooks/use_work_order_action_mutation"

const ReopenWorkOrderModal = ({
  isOpen,
  onClose,
  workOrder,
  workOrderSequentialId,
}) => {
  const { mutate, isLoading, handleCancel } = useWorkOrderActionMutation({
    workOrderSequentialId,
    action: reopenWorkOrder,
    eventPrefix: REOPEN_WORK_ORDER_PREFIX,
    successMessage: "Work order reopened.",
    errorMessage: "Failed to reopen work order.",
    onClose,
  })

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="default">
      <Modal.Header title="Reopen Work Order" />
      <Modal.Body>
        <p className="mb-0 text-sm text-gray-700">
          {`Reopen Work Order #${workOrder.displaySequentialId}? You'll be able to add new jobs and edit existing ones again.`}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-end gap-2">
          <Button
            variant="secondary"
            type="button"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={() => mutate()}
            isLoading={isLoading}
          >
            Reopen Work Order
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

ReopenWorkOrderModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  workOrder: PropTypes.shape({ displaySequentialId: PropTypes.string })
    .isRequired,
  workOrderSequentialId: PropTypes.string.isRequired,
}

export default ReopenWorkOrderModal
